import React from 'react'
import TeacherDash from '../../Components/TeacherComponents/TeacherDash/TeacherDash'
import ChangePassword from '../../Components/TeacherComponents/ChangePassword/ChangePassword'

function ChangePasswordPage() {
  return (
    <TeacherDash>
        <ChangePassword/>
    </TeacherDash>
  )
}

export default ChangePasswordPage